import React from 'react';
import {
  Card, CardContent, Typography, Avatar, Box, Button
} from '@mui/material';
import BusinessIcon from '@mui/icons-material/Business';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import PlaceIcon from '@mui/icons-material/Place';
import EventIcon from '@mui/icons-material/Event';
import './MissionsList.css';

const MissionsList = ({ missions, onView = () => {} }) => {
  const lastMissions = missions.slice(0, 4);

  return (
    <div className="missions-list-compact">
      {lastMissions.map((m, i) => (
        <Card key={m._id || i} className="mission-compact-card" elevation={1}>
          <CardContent className="mission-compact-content">
            <Avatar
              variant="rounded"
              src={m.logoUrl || "/default-logo.png"}
              alt={m.NomEntreprise || "Entreprise"}
              className="mission-compact-avatar"
            />
            <Box className="mission-compact-info">
              <Box className="company-row">
                <BusinessIcon fontSize="small" className="icon-small" />
                <Typography variant="subtitle2" className="company-name" noWrap>
                  {m.NomEntreprise || "Entreprise"}
                </Typography>
              </Box>

              <Typography variant="subtitle1" className="mission-title" noWrap>
                {m.nomMission}
              </Typography>

              {/* CONTEXTE MISSION tronqué à 150 caractères */}
              <Typography
                variant="body2"
                style={{ marginTop: 4, fontSize: '0.85rem', color: '#5a6478' }}
                title={m.contexteMission || ''}
              >
                {m.contexteMission
                  ? (m.contexteMission.length > 150
                      ? m.contexteMission.substring(0, 150) + '…'
                      : m.contexteMission)
                  : 'Pas de description disponible'}
              </Typography>

              <Box className="meta-row">
                <PlaceIcon fontSize="small" className="icon-small" />
                <Typography variant="caption" className="meta-text" noWrap>
                  {m.lieuxTravail || "France"}
                </Typography>

                <EventIcon fontSize="small" className="icon-small" />
                <Typography variant="caption" className="meta-text" noWrap>
                  {new Date(m.createdAt || Date.now()).toLocaleDateString()}
                </Typography>
              </Box>
            </Box>

            <Box className="prime-and-btn">
              <Box className="prime-box">
                <MonetizationOnIcon style={{ color: '#43a047', marginRight: 4 }} />
                <Typography variant="subtitle2" className="prime-text" noWrap>
                  {m.remuneration || 0} {m.devise || ""}
                </Typography>
              </Box>
              <Button
                variant="outlined"
                size="small"
                className="details-btn"
                onClick={() => onView(m._id)}
              >
                DÉTAILS
              </Button>
            </Box>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};

export default MissionsList;
